import React from 'react'

function StoriesWriters() {
  return (
    <div>StoriesWriters</div>
  )
}

export default StoriesWriters